import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Gift = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20.7902 12.21V18.32C20.7902 20.24 19.2402 21.79 17.3202 21.79H6.6702C4.7602 21.79 3.2002 20.24 3.2002 18.32V12.21M16.71 7.98001C17.34 7.45001 17.74 6.67001 17.74 5.79001C17.74 4.20001 16.45 2.92001 14.87 2.92001C13.29 2.92001 12 4.21001 12 5.79001M12 5.79001V21.79M12 5.79001C12 4.21001 10.7098 2.92001 9.12977 2.92001C7.54977 2.92001 6.25977 4.20001 6.25977 5.79001C6.25977 6.67001 6.65977 7.45001 7.28977 7.98001M3.23047 7.98001H20.7805C21.3328 7.98001 21.7805 8.42773 21.7805 8.98001V11.22C21.7805 11.7723 21.3328 12.22 20.7805 12.22H3.23047C2.67818 12.22 2.23047 11.7723 2.23047 11.22V8.98001C2.23047 8.42773 2.67818 7.98001 3.23047 7.98001Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
